<template >
  <div class="wrap" :style="finallyStyle+shapeStyle"></div>
</template>
<script>
import positionMixin from "./positionMixin";
export default {
  mixins: [positionMixin],
  computed: {
    shapeStyle() {
      const { x, y, h, w } = this.shapeInfo;
      return `background-position:${x} ${y};height:${h};width:${w};`;
    }
  },
  props: {
    shapeInfo: {
      type: [Object],
      required: true,
      validator(e) {
        // 必填形状信息
        return e && e.w && e.h;
      }
    }
  }
};
</script>
<style lang='stylus' scoped>
.wrap {
  position: absolute;
  background-repeat: no-repeat;
  background-image: url('../../../assets/indication/indication.png');
}
</style>
